import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/app/admin-settings/automatic-background-jobs"
)({
  component: Outlet,
  beforeLoad: (context) => {
    return {
      getTitle: () => context.context.t && context.context.t("TaskPlanning"),
    }
  },
})
